export const COMPARED_FIELDS = [
  'enabled',
  'alert_threshold_type',
  'alert_threshold_seconds',
  'renotify_enabled',
  'renotify_threshold_seconds',
  'notify_on_resolved',
];

export const BARN_DIFF_REASON = {
  TIER: 'Different policy tier',
  SETTINGS: 'Custom barn settings',
};

function normalizeSettingValue(field, value) {
  if (
    field.includes('seconds') ||
    field === 'enabled' ||
    field === 'renotify_enabled' ||
    field === 'notify_on_resolved'
  ) {
    return Number(value);
  }
  return value;
}

function settingsToMap(rows) {
  const map = new Map();
  (rows || []).forEach((row) => {
    map.set(String(row.code), row);
  });
  return map;
}

export function groupSettingsBy(rows, key) {
  const map = new Map();
  (rows || []).forEach((row) => {
    const groupKey = row[key];
    if (!map.has(groupKey)) {
      map.set(groupKey, []);
    }
    map.get(groupKey).push(row);
  });
  return map;
}

export function groupBarnSettingsByBarnAndTier(rows) {
  const map = new Map();
  (rows || []).forEach((row) => {
    const key = `${row.barn_id}:${row.tier_id}`;
    if (!map.has(key)) {
      map.set(key, []);
    }
    map.get(key).push(row);
  });
  return map;
}

export function haveSameFaultSettings(orgRows, barnRows) {
  const orgMap = settingsToMap(orgRows);
  const barnMap = settingsToMap(barnRows);
  const allCodes = new Set([...orgMap.keys(), ...barnMap.keys()]);

  for (const code of allCodes) {
    const orgRow = orgMap.get(code);
    const barnRow = barnMap.get(code);

    if (!orgRow || !barnRow) {
      return false;
    }

    for (const field of COMPARED_FIELDS) {
      const orgVal = normalizeSettingValue(field, orgRow[field]);
      const barnVal = normalizeSettingValue(field, barnRow[field]);
      if (orgVal !== barnVal) {
        return false;
      }
    }
  }

  return true;
}

export function getBarnPolicyDifference({
  orgAssignedTierId,
  barnAssignedTierId,
  effectiveTierId,
  orgSettingsForBarnTier,
  barnSettings,
}) {
  if (!effectiveTierId) {
    return { differs: false, reasons: [] };
  }

  const reasons = [];

  if (barnAssignedTierId != null && barnAssignedTierId !== orgAssignedTierId) {
    reasons.push(BARN_DIFF_REASON.TIER);
  }

  if (orgSettingsForBarnTier != null) {
    if (!haveSameFaultSettings(orgSettingsForBarnTier, barnSettings || [])) {
      reasons.push(BARN_DIFF_REASON.SETTINGS);
    }
  }

  return {
    differs: reasons.length > 0,
    reasons,
  };
}
